class ScriptService {
    constructor() {
        this.scriptMetadata = new Map();
    }
    recordScriptFunctionCall(script, functionName) {
        let metadata = this.scriptMetadata.get(script.scriptIdx);
        if (metadata === undefined) {
            metadata = {
                scriptIdx: script.scriptIdx,
                scriptId: script.scriptId,
                methods: new Map()
            };
            this.scriptMetadata.set(script.scriptIdx, metadata);
        }
        else if (metadata.scriptId === undefined) {
            metadata.scriptId = script.scriptId;
        }
        let methodMetadata = metadata.methods.get(functionName);
        if (methodMetadata === undefined) {
            methodMetadata = {};
            metadata.methods.set(functionName, methodMetadata);
        }
        methodMetadata.lastCalledAt = Date.now();
    }
    getScriptMetadata(scriptOrIdx) {
        const scriptIdx = typeof scriptOrIdx === "number" ? scriptOrIdx : scriptOrIdx.scriptIdx;
        const existingMetadata = this.scriptMetadata.get(scriptIdx);
        if (typeof scriptOrIdx === "number")
            return existingMetadata;
        if (existingMetadata !== undefined)
            return existingMetadata;
        const metadata = {
            scriptIdx: scriptOrIdx.scriptIdx,
            scriptId: scriptOrIdx.scriptId,
            methods: new Map()
        };
        this.scriptMetadata.set(scriptOrIdx.scriptIdx, metadata);
        return metadata;
    }
}
export const scriptService = new ScriptService();
